import type { ReactNode } from "react";

import { cn } from "@krea/shared/utils";

import { DataStatusIndicator } from "../data-status-indicator";

export const DetailsItemGridData = ({
  title,
  value,
  tooltip,
  indicator,
  isDone,
  notExists,
  complex,
  colSpan,
}: {
  title: string;
  value?: string | ReactNode;
  tooltip?: string;
  indicator?: boolean;
  isDone?: boolean;
  notExists?: boolean;
  complex?: boolean;
  colSpan?: "full" | "2";
}) => {
  const notExistsText = "No information";
  const data = notExists ? notExistsText : value;

  const item = (
    <div
      className={cn(
        "flex flex-col gap-1",
        colSpan === "full" && "col-span-full",
        colSpan === "2" && "col-span-2",
      )}
    >
      <dt className={cn("p-0", complex ? "text-subsection" : "text-label")}>
        {title}
      </dt>
      <dd
        className={cn("flex items-start justify-between p-0", {
          "opacity-50": notExists,
        })}
      >
        <div className="w-full text-base-strong">{data}</div>
        {indicator && (
          <DataStatusIndicator
            tooltip={!notExists ? tooltip : notExistsText}
            isDone={isDone}
            notExists={notExists}
          />
        )}
      </dd>
    </div>
  );

  if (complex) {
    return (
      <>
        {item}
        <div className="col-span-full border-b border-gray-200 last:hidden" />
      </>
    );
  }

  return item;
};
